/**
 * AutoScanOnOpen — mounts the launch/foreground Auto Scan sweep
 * (lib/autoScanOnOpen) once, inside SessionProvider so the sweep reads the
 * live tier for its Pro gate. Never renders.
 */
import { useEffect, useRef } from "react";

import { hasProAccess, useSession } from "@/components/SessionProvider";
import { startAutoScanOnOpen } from "@/lib/autoScanOnOpen";

export function AutoScanOnOpen() {
  const { tier } = useSession();
  const isProRef = useRef(hasProAccess(tier));
  isProRef.current = hasProAccess(tier);

  useEffect(() => startAutoScanOnOpen(() => isProRef.current), []);

  return null;
}
